export function propertyEditorKey(node, context) {
    if (!node) return `property-editor:none:${context}`
    const designerId = typeof node.id === 'function' ? node.id() : node.id
    const identity = designerId || node._id || node.haspid
    return `property-editor:${node.obj ?? 'object'}:${identity}:${context}`
}
